import { render, staticRenderFns } from "./CareersItem.vue?vue&type=template&id=4356d4ea&"
import script from "./CareersItem.vue?vue&type=script&lang=js&"
export * from "./CareersItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CareersItem.vue"
export default component.exports